<div class="admin" [ngClass]="{'dark': darkMode}">
    <app-kin-training-navbar></app-kin-training-navbar>
    <app-admin-subnav [listItems]="listItems" [darkMode]="darkMode"></app-admin-subnav>
    <router-outlet></router-outlet>
</div>